// components/AuthHandler.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';

const AuthHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    
    // Firebase will automatically handle the redirect result
    auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in, redirect to appropriate page
        navigate('/');
      } else {
        // No user, redirect to login
        navigate('/login');
      }
    });
  }, [navigate]);

  return <div>Processing authentication...</div>;
};

export default AuthHandler;